import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import AppStart from './components/AppStart.vue';
import Listing from './components/PagedItems.vue';
import Articles from './components/PagedArticles.vue';
import ArticleDetail from './components/ArticleDetail.vue';
import ItemDetail from './components/ItemDetail.vue';
import Policies from './components/Policies.vue';
import AboutUs from './components/AboutUs.vue';
import Index from './components/Index.vue';
import Cart from './components/PagedCartItems.vue';
import LocalCart from './components/PagedCartItemsLocal.vue';
import Orders from './components/PagedOrders.vue';
import OrderDetail from './components/OrderDetail.vue';
import Account from './components/Account.vue';
import Register from './components/Register.vue';
import ForgotLogin from './components/ForgotLogin.vue';
import { Promise } from 'core-js';
import { setTimeout } from 'timers';
import apis from './api/extApiFrontend.js';
import {langReference,getLanguageByNature} from './api/lang.js';

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(Vuex);

var currentShop = apis.api.currentShop;
var shopNatureName = currentShop.configs.shopNature[currentShop.shop.viewCatId];

const store = new Vuex.Store({
    state: {
        account: null,
        showingLogin: false,
        appSpec: { isApp: false }
    },
    mutations: {
        setAccount(state, payload) {
            state.account = payload;
        },
        setShowLogin(state, payload) {
            state.showingLogin = payload;
        },
        setAppSpec(state, payload) {
            state.appSpec = payload;
        }
    },
    getters: {
        // shopNatureName:state=>{
        //     return shopNatureName;
        // },
        lang: state => {
            //console.log('lang ref',langReference,shopNatureName);
            return getLanguageByNature({language:langReference.lang, shopNatureName:shopNatureName});
            //return getLanguageByNature('Chinese',state.shopNatureName);
        },
        configs: state => {
            return currentShop.configs;
        },
        shopConfigs: state => {
            return {
                needDeliveryAddress:shopNatureName!=='RealEstate',
                needItemQuant:shopNatureName!=='RealEstate',
                payCashEnabled: currentShop.shop.payCashEnabled,
                payFpsEnabled: currentShop.shop.payFpsEnabled,
                payAtmEnabled: currentShop.shop.payAtmEnabled,
                payPalEnabled: currentShop.shop.payPalEnabled,
                payMeEnabled: currentShop.shop.payMeEnabled,
                payAliEnabled: currentShop.shop.payAliEnabled,
                payWechatEnabled: currentShop.shop.payWechatEnabled
            };
        },
        account: state => {
            return state.account;
        },
        showingLogin: state => {
            return state.showingLogin;
        },
        showNavBack: state => {
            return state.appSpec.isApp === true;
        },
        navBarBottom: state => {
            return false;
        }
    }
});


var onLoginListeners = [];

var onLoginApi = {
    on: function (listener) {
        onLoginListeners.push(listener);
    },
    remove: function (listener) {
        var index = onLoginListeners.indexOf(listener);
        if (index >= 0) {
            onLoginListeners.splice(index, 1);
        }
    }
};

function onLogout() {
    store.commit("setAccount", null);
    vueInst.$router.push({ path: "/" });
}

var _listenerRef = {
    onShare: null,
    onPromptLogin: null,
    onLogoutListener: null,
    onLogout: onLogout,
    store: store
};

var apiCompo = apis.api.getCompoApiClient({
    onLoginApi: onLoginApi,
    listenerRef: _listenerRef
});

const routes = [
    {
        name: 'forgotLogin', path: "/forgotLogin", component: ForgotLogin
    },
    {
        name: 'register', path: "/register", component: Register
    },
    {
        name: 'account', path: "/account", component: Account
    },
    {
        name: 'orders', path: "/orders", component: Orders
    },
    {
        name: 'orderDetail', path: "/orderDetail", component: OrderDetail, props: (route) => ({
            orderId: route.query.orderId
        })
    },
    {
        name: 'cart', path: "/cart", component: Cart
    },
    {
        name: 'wishList', path: "/wishList", component: LocalCart
    },
    {
        name: 'listing', path: "/listing", components: {
            cacheview: Listing
        },
        props: {
            cacheview: (route) => ({
                filterInfo: currentShop.filterInfo
            })
        }
    },
    {
        name: "detail", path: "/detail",
        beforeEnter(to, from, next) {
            setListingPosition('listing', to, from, next);
        },
        component: ItemDetail, props: (route) => ({
            postId: route.query.postId
        })
    },
    {
        name: 'articles', path: "/articles",
        //component: Articles,
        components: {
            cacheArticles: Articles
        },
        props:(route) => ({
                filterInfo: currentShop.filterInfo
            })
    },
    {
        name: 'articleDetail', path: "/articleDetail",
        beforeEnter(to, from, next) {
            setListingPosition('articles', to, from, next);
        },
        component: ArticleDetail,
        props: (route) => ({
            postId: route.query.postId
        })
    },
    {
        name: 'policies', path: "/policies", component: Policies
    },
    {
        name: 'about', path: "/about", component: AboutUs, props: (route) => ({ shopInfo: shopInfo })
    },
    {
        name: 'index', path: "/",
        //component: Index,
        components: {
            cacheindex: Index
        },
        props: {
            cacheindex: (route) => ({
                configs: currentShop.configs,
                sliderData: currentShop.sliderData,
                filterInfo: currentShop.filterInfo
            })
        },
        //props: (route) => ({ configs: currentShop.configs })
    }
];

//scrollBehavior handling
var _scApi = (function () {
    var _onScrollListeners = [];
    var _onScrollApi = {
        on: function (listener) {
            _onScrollListeners.push(listener);
        },
        remove: function (listener) {
            var index = _onScrollListeners.indexOf(listener);
            if (index >= 0) {
                _onScrollListeners.splice(index, 1);
            }
        },
        listeners: _onScrollListeners
    };

    return _onScrollApi;
})();


var listingPosition = { x: 0, y: 0 };
function onScrollResolve(resolve, to, from, savedPosition) {
    for (var i = 0; i < _scApi.listeners.length; i++) {
        var cbs = _scApi.listeners[i];
        if (cbs.onScrollResolve) {
            cbs.onScrollResolve(resolve, listingPosition,  to, from, savedPosition);
        }
    }
}
function setListingPosition(listPageName, to, from, next) {
    for (var i = 0; i < _scApi.listeners.length; i++) {
        var cbs = _scApi.listeners[i];
        if (cbs.onKeepPosition) {
            listingPosition.y = cbs.onKeepPosition(listPageName, to, from, next);
        }
    }
    next();
}
//end scrollBehavior handling

var router = new VueRouter({
    mode: "history",
    //mode: "hash",
    //base:"./",
    //base:"/Shopping/Shopspa/master",
    base: "/site/" + currentShop.shop.shopCode,
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        return new Promise(resolve => {
            setTimeout(() => {
                onScrollResolve(resolve, to, from, savedPosition);
            }, 50);
        });
    }
});


apiCompo.apiClient.netClient.setOn401(function () {
    console.log("on 401");
    store.commit("setAccount", null);
    if (_listenerRef.onPromptLogin === null) {
        store.commit("setShowLogin", true);
    } else {
        _listenerRef.onPromptLogin();
    }
});


var mxnApis = {
    data: function () {
        return {
            mxnAgxApi: apiCompo,
            mxnAgxScrollApi: _scApi,
            mxnShopNatureName:shopNatureName
        }
    },
    methods:{
        mxnAgxShowLogin:function(){
            window.vueInst.showLogin(true);
        }
    }
};

Vue.mixin(mxnApis);//goes to all component

var vueInst = new Vue({
    //mixins: [mxnApis],//goes to only this instance, not even the components below it
    store: store,
    components: {
        AppStart: AppStart
    },
    data: function () {
        return {
            shopInfo: currentShop.shop,
            filterInfo: currentShop.filterInfo,
            sliderData: currentShop.sliderData,
            enableLsToken: false,
            currentUrl: window.location.href,
            spaPageChangeListeners: []
        }
    },
    computed: {
        lang: function () {
            return this.$store.getters.lang;
        }
    },
    methods: {
        onShare: function () {
            if (_listenerRef.onShare) {
                _listenerRef.onShare();
            }
        },
        onLoginCallback: function (e) {
            onLoginListeners.forEach((func) => {
                func(e);
            });
        },
        loadProfile: function () {
            this.isLoading = true;
            var that = this;
            apiCompo.apiClient.getProfilePrms().done(function (e) {
                that.isLoading = false;
                if (e.ok === true) {
                    store.commit("setAccount", e.value);
                }
            }).fail((ret) => {
                that.isLoading = false;
            });
        },
        clearProfile: function () {
            store.commit("setAccount", null);
        },
        setPromptShare: function (listener) {
            _listenerRef.onShare = listener;
        },
        setPromptLogin: function (listener) {
            _listenerRef.onPromptLogin = listener;
        },
        setPromptLogout: function (listener) {
            _listenerRef.onLogoutListener = listener;
        },
        onSpaPageChange: function (listener) {
            this.spaPageChangeListeners.push(listener);
        },
        showLogin: function (toShow) {
            console.log('main showLogin, toShow = ', toShow);
            if (_listenerRef.onPromptLogin !== null) {
                _listenerRef.onPromptLogin();
            } else {
                store.commit("setShowLogin", toShow);
            }
        },
        setForApp: function (isApp) {
            this.$store.commit("setAppSpec", { ...this.$store.appSpec, isApp: isApp });
        }
    },
    watch: {
        '$route'() {
            this.currentUrl = window.location.href;
            var urlData = { currentUrl: this.currentUrl, spaFullPath: this.$router.currentRoute.fullPath };
            apiCompo.apiClient.onSpaPageChange(urlData);
            if (this.spaPageChangeListeners.length > 0) {
                this.spaPageChangeListeners.forEach((itemFunc, index, arr) => {
                    itemFunc(urlData);
                });
            }
        }
    },
    created: function () {

    },
    mounted: function () {

    },
    router: router,
    el: "#app"
});

//default sharing
vueInst.setPromptShare(function () {
    console.log('default sharing');
    if (navigator.share) {
        try {
             navigator.share({
                title: 'Share',
                text: '',
                url: window.location.href,
            });
           
        } catch (err) {
            console.log('Error sharing: ', err);
        }
    } else {
        console.log('Web Share API not supported in this browser.');
    }
});

window.vueInst = vueInst;
window.storeInst = store;



